import React from 'react';
import { image } from '../../../app/utils/common/image';
import { useLocation, useNavigate } from 'react-router-dom';
import './BottomSheet.scss';
import { useSelector } from 'react-redux';
import { selectRoleId } from '../../../redux/Slices/SelectRoleSlice';
import { selectRoleJoinId } from '../../../redux/Slices/JoinGameSlice';
import sendFirebaseEvent from '../../../app/firebase/sendFirebaseEvent';

const BottomSheet = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const roleId = useSelector(selectRoleId);
    const joinRoleId = useSelector(selectRoleJoinId);
    const roleIdStock = joinRoleId !== undefined ? joinRoleId : roleId;

    return (
        <div className='bottomsheet-container'>
            <div className={`${roleIdStock === 1 ? 'bottomSheet-brok' : 'bottomSheet'}`}>
                <div className='flex bottom-btns' onClick={() => { navigate('/stock-prices'); sendFirebaseEvent('market_monitor_button', 'user_action', 'market_monitor_button', "Market Monitor Button Clicked") }}>
                    <img src={location.pathname === '/stock-prices' || location.pathname === '/price-updates' ? image.STOCKSELCBTN : image.STOCKTABBTN} className='trade-btn'
                        draggable="false"
                        onContextMenu={(e) => e.preventDefault()} />
                    <div className='bottom-text'>Market Monitor</div>
                </div>
                {roleIdStock !== 1 && <div className='flex bottom-btns' onClick={() => { navigate('/portfolio'); sendFirebaseEvent('portfolio_button', 'user_action', 'portfolio_button', "Portfolio Button Clicked") }}>
                    <img src={location.pathname === '/portfolio' ? image.PORTFOLIOSELCBTN : image.PORTFOLIOTABBTN} className='trade-btn'
                        draggable="false"
                        onContextMenu={(e) => e.preventDefault()} />
                    <div className='bottom-text'>Portfolio</div>
                </div>}
                {roleIdStock !== 1 && <div className='flex bottom-btns' onClick={() => { navigate('/trade'); sendFirebaseEvent('trade_hub_button', 'user_action', 'trade_hub_button', "Trade Hub Button Clicked") }}>
                    <img src={location.pathname === '/trade' ? image.TRADESELCBTN : image.TRADETABBTN} className='trade-btn'
                        draggable="false"
                        onContextMenu={(e) => e.preventDefault()} />
                    <div className='bottom-text'>Trade Hub</div>
                </div>}
                <div className='flex bottom-btns' onClick={() => { navigate('/transaction'); sendFirebaseEvent('history_button', 'user_action', 'history_button', "History Button Clicked") }}>
                    <div className={location.pathname !== '/transaction' ? 'history-bg' : 'history-linear-bg'}>
                        <img src={location.pathname === '/transaction' ? image.TRANSCTABBTN : image.TRANSCSELCBTN} className='trade-btn'
                            draggable="false"
                            onContextMenu={(e) => e.preventDefault()} />
                    </div>
                    <div className='bottom-text'>History</div>
                </div>
            </div>
        </div>
    )
}

export default BottomSheet